export default {
  mounted() {
    if (
      localStorage.filterParams
      && localStorage.filterParams !== 'undefined'
    ) {
      this.filterParams = JSON.parse(localStorage.filterParams);
    }
  },
  watch: {
    filterParams: {
      handler() {
        localStorage.filterParams = JSON.stringify(this.filterParams);
      },
      deep: true,
    },
  },
};
